import axios from 'axios';
import { apiAddress } from '../settings'

class BlogAPI {
    apiURL = apiAddress + '/blog/api/';

    getPostsList(limit, page, special = false) {
        const offset = (page * limit) - limit
        const url = this.apiURL + "posts/?limit=" + limit + "&offset=" + offset + "&special=" + special
        return axios.get(url).then(function (response) {
            return {
                "success": true,
                "data": response.data
            }
        }).catch(function (error) {
            return {
                "success": false,
                "error": error.response
            }
        })
    }

    getPostDetail(postID) {
        return axios.get(this.apiURL + "post/" + postID + "/").then(function (response) {
            return {
                "success": true,
                "data": response.data
            }
        }).catch(function (error) {
            return {
                "success": false,
                "error": error.response
            }
        })
    }
}

export default BlogAPI
